<template>
  <div>
    <i4proDetailPage v-if="'master' in schema" :schema="schema.master" :model="entryModel" :mode="mode" :page="page" />

    <v-stepper v-model="activeStep" vertical>
      <template v-for="step in storeHeaders.filter(header => header.show === true)">
        <v-stepper-step
          :name="`step-${step.id}`"
          :id="`step-${step.id}`"
          :complete="activeStep > step.id"
          :step="step.id"
          :key="step.title"
          :editable="activeStep > step.id || activeStep === step.id"
          :edit-icon="stepIcon"
          :color="stepIconColor"
          @click="reloadStep(step.id)"
        >
          {{ step.title }}
          <small v-if="step.subtitle.length">{{ step.subtitle }}</small>
        </v-stepper-step>

        <v-stepper-content :step="step.id" :key="step.id">
          <v-form v-model="valid" ref="form">
            <template v-if="schema.content[step.id].groups.length">
              <i4proColumnGroup
                v-for="group in schema.content[step.id].groups"
                :key="group.name"
                :schema="group"
                :mode="mode"
                :page="page"
                :step="activeStep"
              />
            </template>

            <v-row>
              <v-col v-if="schema.content[step.id].fields.length" class="pt-0 pb-0" cols="12" sm="12" md="12">
                <i4proColumnFields :page="page" :mode="mode" :schema="schema.content[step.id].fields" :step="activeStep" />
              </v-col>

              <v-col class="action-no-padding" sm="12" md="12">
                <i4proActions
                  :page="page"
                  :mode="mode"
                  :origin="origin"
                  :isValid="valid"
                  @isValid="validate"
                  :step="activeStep"
                  :tag="'v-card-actions'"
                  :mustValidate="true"
                />
              </v-col>

              <!--
            <v-col
              v-if="actions && actions.step === step.id"
              class="pt-0 pb-0"
              cols="12"
              sm="12"
              md="12"
            >
              <i4proActions
                :page="page"
                :mode="mode"
                :origin="origin"
                :isValid="valid"
                @isValid="validate"
                :step="activeStep"
                :tag="'v-card-actions'"
                :mustValidate="true"
              />
              </v-col>-->
            </v-row>
          </v-form>
        </v-stepper-content>
      </template>
    </v-stepper>
  </div>
</template>

<script>
import * as HANDLERS from '@/helpers/types/handlers';
import store from '@/store';

export default {
  components: {
    i4proColumnGroup: () => import('@/components/partials/i4pro-column-group'),
    i4proActions: () => import('@/components/partials/i4pro-actions'),
    i4proColumnFields: () => import('@/components/partials/i4pro-column-fields'),
    i4proDetailPage: () => import('@/components/detail/i4pro-detail-page')
  },

  props: {
    page: { type: String, required: true, default: null },
    schema: { type: Object, default: () => ({}), required: true },
    mode: { type: String, default: undefined },
    origin: { type: String, required: false, default: 'page' },
    stepEditable: { type: Boolean, default: false },
    stepIcon: { type: String, default: undefined },
    stepIconColor: { type: String, default: undefined }
  },

  data: () => ({
    valid: false,
    activeStep: 0
  }),

  mounted() {
    const step = this.$store.getters['page/currentStep'](this.page);
    this.$nextTick(() => (this.activeStep = step || 1));
  },

  events: {
    [HANDLERS.VALIDATE_STEP]: 'validate',
    [HANDLERS.CHANGE_STEP]: 'changeStep',
    [HANDLERS.SHOW_GROUPS]: 'showGroups',
    [HANDLERS.HIDE_GROUP]: 'hideGroup'
  },

  computed: {
    // actions() {
    //   if (!this.page || !this.mode) return;

    //   return store.getters['page/actions_scheme']({
    //     page: this.page,
    //     mode: this.mode,
    //     step: this.activeStep
    //   });
    // },

    storeHeaders() {
      return this.$store.getters['page/schema']({
        page: this.page,
        mode: this.mode
      }).steps.headers;
    },

    entryModel() {
      return this.$store.getters['page/entryModel'](this.page);
    }
  },

  methods: {
    showGroups({ page, mode, step }) {
      if (!step) return;

      if (this.page !== page || this.mode !== mode) return;

      for (let group in this.schema.content[step].groups) this.schema.content[step].groups[group].visible = true;
    },

    hideGroup({ page, mode, step, group }) {
      if (!step) return;

      if (this.page !== page || this.mode !== mode) return;

      this.schema.content[step].groups[group].visible = false;
    },

    validate(page) {
      if (this.page !== page) return;

      let valid = this.$refs['form'][this.activeStep - 1].validate();

      if (valid) this.valid = true;
      else {
        this.valid = false;

        store.dispatch('notification/showNotification', {
          color: 'error',
          text: 'Existem campos obrigatórios não preenchidos',
          showIconNotification: false
        });
      }
    },

    async reloadStep(index) {
      index === this.activeStep && (await this.$store.dispatch('page/loadStep', { page: this.page, step: this.activeStep, mode: this.mode }));
    },

    changeStep({ step }) {
      this.activeStep = step;
    }
  },

  watch: {
    async activeStep(newValue) {
      await this.$store.dispatch('page/loadStep', { page: this.page, step: newValue, mode: this.mode });
      await this.$store.dispatch('page/loadLookups', { page: this.page, step: newValue, mode: this.mode });

      this.$store.dispatch('page/conditions', { page: this.page, mode: this.mode, step: newValue });
    },

    entryModel() {
      deep: true, this.reloadStep(this.activeStep);
    }
  }
};
</script>

<style scoped lang="scss">
.v-stepper__header {
  height: auto;
}

.v-stepper__step {
  padding: 12px 24px;
}

.v-stepper--vertical {
  .v-stepper__content {
    padding: 16px 46px 16px 10px;

    .v-form {
      min-height: 160px;
      display: flex;
      flex-wrap: wrap;
      flex: 1 1 auto;
      margin: 0;
    }
  }
}
</style>
